'use client';

import React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@/app/lib/utils';

interface RangeSliderProps {
  min?: number;
  max?: number;
  step?: number;
  value?: [number, number];
  defaultValue?: [number, number];
  onValueChange?: (value: [number, number]) => void;
  label?: string;
  required?: boolean;
  className?: string;
  showValues?: boolean;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  min = 0,
  max = 100,
  step = 1,
  value,
  defaultValue = [min, max],
  onValueChange,
  label,
  required,
  className,
  showValues = true,
}) => {
  const currentValue = value ?? defaultValue;

  return (
    <div className={cn('flex flex-col', className)}>
      {label && (
        <label className="text-sm font-medium mb-1.5 text-foreground">
          {label}
          {required && <span className="text-red-600 ml-1">*</span>}
        </label>
      )}
      <div className="flex flex-col gap-1">
        {showValues && (
          <div className="flex items-center justify-between text-xs text-muted-foreground">
            <span>{currentValue[0]}</span>
            <span>{currentValue[1]}</span>
          </div>
        )}
        <SliderPrimitive.Root
          className="relative flex items-center select-none touch-none w-full h-5"
          min={min}
          max={max}
          step={step}
          value={currentValue}
          onValueChange={v => onValueChange?.(v as [number, number])}
        >
          <SliderPrimitive.Track className="relative h-1.5 grow rounded-full bg-secondary">
            <SliderPrimitive.Range className="absolute h-full rounded-full bg-primary" />
          </SliderPrimitive.Track>
          <SliderPrimitive.Thumb className="block h-4 w-4 cursor-pointer rounded-full border border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
          <SliderPrimitive.Thumb className="block h-4 w-4 cursor-pointer rounded-full border border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
        </SliderPrimitive.Root>
      </div>
    </div>
  );
};

export default RangeSlider;
